// Vào ca / Đổi ca cho office mode (AntMainHeader). Nút bấm trong header
// → click mở AntShiftActionOverlay (PIN-first lookup, BE tự nhận diện
// nhân viên theo PIN trong phạm vi user_code hiện tại, không đổi user).
import React, { useCallback, useMemo, useState } from 'react';
import Button from 'devextreme-react/button';
import { RiCalendarCheckFill } from 'react-icons/ri';

import AntLocalization from '../../../utils/AntLocalization';
import AntAuth from '../../../utils/AntAuth.js';
import AntShiftActionOverlay from '../../AntShiftActionOverlay';
import './index.scss';

export default function (props) {
    const [popupVisible, setPopupVisible] = useState(false);

    const session = useMemo(
        () => ({
            employee_code: AntAuth.getSessionInfo('employee_code'),
            employee_name: AntAuth.getSessionInfo('employee_name'),
            employee_session_status: AntAuth.getSessionInfo('employee_session_status'),
            shift_id: AntAuth.getSessionInfo('shift_id'),
            store_name: AntAuth.getSessionInfo('store_name'),
            store_code: AntAuth.getSessionInfo('store_code')
        }),
        [popupVisible]
    );

    const onShowPopupClick = useCallback(() => setPopupVisible(true), []);
    const onClose = useCallback(() => {
        setPopupVisible(false);
        if (props.onPopupClose) props.onPopupClose();
    }, [props.onPopupClose]);
    const onDone = useCallback(() => {
        setPopupVisible(false);
        if (props.onCheckedin) props.onCheckedin();
        try { window.location.reload(); } catch (e) { /* ignore */ }
    }, [props.onCheckedin]);

    return (
        <div>
            <Button
                id={'switchEmployeeShiftCheckin'}
                className={'ant-employee-shift-checkin-button'}
                width={'auto'}
                height={'100%'}
                stylingMode={'text'}
                onClick={onShowPopupClick}
            >
                <div className={'ant-employee-shift-checkin-panel'}>
                    <div className={'ant-employee-shift-checkin'}>
                        <RiCalendarCheckFill className={'ant-employee-shift-checkin-image'} />
                        <div className={'ant-employee-shift-checkin-name'}>
                            {AntLocalization.translateText({ vi: 'Vào ca', en: 'Start Shift', fr: 'Début de poste', es: 'Iniciar turno', id: 'Mulai shift', ja: 'シフト開始', zh: '开始班次', ko: '근무 시작', hi: 'शिफ्ट शुरू', ar: 'بدء الوردية' })}
                        </div>
                    </div>
                </div>
            </Button>
            {popupVisible && (
                <AntShiftActionOverlay mode="checkin" session={session} onDone={onDone} onClose={onClose} />
            )}
        </div>
    );
}
